var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"DataPoint"},[_c('Set',{staticClass:"lg",attrs:{"icon":_vm.icon,"name":_vm.label}},[_vm._v(" "+_vm._s(_vm.value)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }